import { jsx as _jsx } from "react/jsx-runtime";
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { store } from './store';
import { queryClient, apiClient } from './api/client';
import { loadEnvironment, getEnv } from './config';
import { AuthProvider } from './auth/AuthProvider';
import { initAuthConfig } from './auth/AuthClient';
import App from './App';
void (async () => {
    await loadEnvironment();
    const apiBaseUrl = getEnv('API_BASE_URL') || process.env.REACT_APP_API_BASE_URL || '';
    apiClient.defaults.baseURL = apiBaseUrl;
    initAuthConfig();
    const root = document.getElementById('root');
    if (!root) {
        throw new Error('Root element #root not found');
    }
    createRoot(root).render(_jsx(StrictMode, { children: _jsx(Provider, { store: store, children: _jsx(QueryClientProvider, { client: queryClient, children: _jsx(BrowserRouter, { children: _jsx(AuthProvider, { children: _jsx(App, {}) }) }) }) }) }));
})();
